import { ByteArray } from "../ByteArray"
import { ICommand } from "./ICommand"

export class CMDBaccaratSqueezeCountDown implements ICommand
{

	public BetCountDown : number = 0;
	public SqueezePerCardCountDown : number = 0;
	public Delay : number = 0;

	public constructor()
	{
	}

	public fromBytes(ba : ByteArray) : void
	{
		this.BetCountDown = ba.readUint32();
		this.SqueezePerCardCountDown = ba.readUint32();
		this.Delay = ba.readUint32();
	}

	public toBytes() : ByteArray
	{
		let ba: ByteArray = new ByteArray();

		ba.writeUint32(this.BetCountDown);
		ba.writeUint32(this.SqueezePerCardCountDown);
		ba.writeUint32(this.Delay);

		return ba;
	}

	public clone() : ICommand
	{
		let cmd : ICommand = new CMDBaccaratSqueezeCountDown();
		cmd.fromBytes(this.toBytes());

		return cmd;
	}

	public toString() : string
	{
		let str:string = '';
		str += 'BetCountDown(D)='+this.BetCountDown+' ';
		str += 'SqueezePerCardCountDown(D)='+this.SqueezePerCardCountDown+' ';
		str += 'Delay(D)='+this.Delay+' ';
		return str;
	}

	public getCmdID() : number
	{
		return 0;
	}

	public getCmdName() : string
	{
		return 'BaccaratSqueezeCountDown';
	}

}
